import React, { useRef, useEffect } from "react";
import { basePath } from "../../config";
// import { Document } from "react-pdf";

export const TermsAgreementScroller = ({
  heading,
  headingStyle,
  html,
  fileURL, //Not currently working, the idea was to display pdfs as html. But couldn't get pdfJS or react-pdf(relies on pdfJS) working. Alternative was to hard code the height of the embed element at different viewport widths. Went with just copy pasting the contents of the file as html, for now.
  onScrolledToEnd,
  onScrolledAwayFromEnd,
  prependBasePath,
  doOnce,
  endOfDocumentMessage = "",
  ...props
}) => {
  const scrollCheckerRef = useRef();
  const triggeredCount = useRef(0); //this will only increment when scrollChecker element comes into viewport
  useEffect(() => {
    let observer = new IntersectionObserver(([observerEntry]) => {
      //   console.log(observerEntry);
      if (observerEntry.isIntersecting) {
        if (!(doOnce && triggeredCount.current > 0)) {
          //   console.log("Is intersecting");
          onScrolledToEnd && onScrolledToEnd();
        }
        triggeredCount.current++;
      }
      //if we got here it means we scrolled away from end after having been there (Using triggeredCount to avoid running this when first rendering the page)
      if (
        !observerEntry.isIntersecting && //this is true on first render or if the element left the view
        triggeredCount.current > 0 && // to avoid triggering on first render
        !(doOnce && triggeredCount.current > 1) //if it is doOnce, only do once. Using 1 here because:
      ) {
        //if trigger count is greater than 1, i.e. 2 or more. We have previously scrolled to the end, left, and scrolled back.
        onScrolledAwayFromEnd && onScrolledAwayFromEnd();
      }
    });
    observer.observe(scrollCheckerRef.current);
    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  });
  return (
    <div
      {...props}
      style={{
        height: "500px",
        overflowY: "scroll",
        // backgroundColor: "yellow",
        padding: 0,
        margin: 0,
        border: "1px solid rgb(200,200,200)",
        // boxShadow: "0px 0px 5px 0px rgba(0,0,0,.25) inset",
      }}
    >
      {/* <Document file={file} /> */}
      <div
        style={{
          //   height: "2500px",
          //   backgroundColor: "red",
          padding: "20px",
          margin: 0,
          // backgroundColor: "white",
          color: "black",
        }}
      >
        {/* <iframe
          id="pdfFrame"
          src={prependBasePath ? basePath + fileURL : fileURL}
          style={{
            width: "100%",
            height: "100%",
            border: 0,
            backgroundColor: "green",
            padding: 0,
            margin: 0,
          }}
        ></iframe> */}
        <h5 className="text-center p-3 m-auto" style={headingStyle}>
          {" "}
          {heading}{" "}
        </h5>
        {html}
      </div>
      <div
        style={{
          paddingTop: "100px",
          paddingBottom: "100px",
          // backgroundColor: "white",
          display: "grid",
          placeContent: "center",
          color: "black",
        }}
      >
        <div ref={scrollCheckerRef}>{endOfDocumentMessage}</div>
      </div>
    </div>
  );
};
